import { getFileById } from '@/api/file/fileApi';
import { INIT_NO_OP_NUM, REPORT_FILE_TYPE } from '@/config';
import { getProviderByNpi } from '@/api/getters/provider';
import {
  getDescByCcd
} from '@/data/getters';
import { setReport, clearReport } from '@/mutation-types';

const state = {
  reportId: INIT_NO_OP_NUM,    // id in db
  reportIndex: INIT_NO_OP_NUM, // id in dropdown list
};

const getters = {
  getReportId: state => state.reportId,
  getReportIndex: state => state.reportIndex,

  /**
   * returns a list of all reports: id with display name
   */
  getReportList (state, getters, rootState, rootGetters) {
    const allData = rootGetters['login/getAllData'];

    let reportList = [];
    if (allData && allData.reports) {
      allData.reports.forEach((report,index) => {
        let displayName = `${report.when} - ${getDescByCcd(report.procCcd,allData) || getDescByCcd(report.category,allData) || getProviderByNpi(allData,report.npi).fullDesc}`;
        reportList.push({id:report.id, index, displayName });
      });
    }
    return reportList;
  },
  getIndexOfLastReport (state, getters, rootState) {
    return rootState.login.phrData.reports.length-1;
  },
  getReportDescriber(state,getters,rootState) {
    return selectedReport  => {
      const allData = rootState.login.phrData;
      if(!allData)
        return false;
      const report = allData.reports[selectedReport];
      if (!report) return false;
      const npiData = allData.npis[report.npi];
  
      return {
        id: state.reportId,
        index: state.reportIndex,
        npi: npiData.npi,
        documentType: report.category?rootState.login.phrData.ccds[report.category].desc:'Report',
        provider: getProviderByNpi(allData, report.npi),
        date: report.when,
        ccdDescription: report.ccdDescription ? report.ccdDescription : '',
        procedure: report.procCcd?rootState.login.phrData.ccds[report.procCcd].desc : 'N/A',
      }
    };
  },
  getReportDesc (state, getters, rootState) {
    const allData = rootState.login.phrData;
    if(!allData)
      return false;
    const report = allData.reports[state.reportIndex];
    if (!report) return;
    const npiData = allData.npis[report.npi];

    return {
      id: state.reportId,
      index: state.reportIndex,
      npi: npiData.npi,
      documentType: report.category?rootState.login.phrData.ccds[report.category].desc:'Report',
      provider: getProviderByNpi(allData, report.npi),
      date: report.when,
      ccdDescription: report.ccdDescription ? report.ccdDescription : '',
      procedure: report.procCcd?rootState.login.phrData.ccds[report.procCcd].desc : 'N/A',
    }
  }
};

const mutations = {
  [setReport] (state, payload) {
    state.reportId = parseInt(payload.reportId);
    state.reportIndex = parseInt(payload.reportIndex);
  },
  [clearReport] (state) {
    state.reportId = INIT_NO_OP_NUM;
    state.reportIndex = INIT_NO_OP_NUM;
  }
};

const actions = {
  requestReportById ({state,commit}, id) {
    return new Promise((resolve, reject) => {
      getFileById(REPORT_FILE_TYPE, id)
      .then((response) => {
        resolve(response.report);
      })
      .catch((err) => {
        reject(err);
      });
    });
  },

  clearReport ({commit}) {
    commit(clearReport);
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
